import { Component, OnInit } from '@angular/core';
import { URL_DOCS } from 'src/app/config/config';
import { DocumentsService } from 'src/app/services/documents.service';
import { GeneralService } from 'src/app/services/general.service';
import Swal from 'sweetalert2';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { environment } from 'src/environments/environment.dev';

declare var $: any;
declare var Examedi: any;

@Component({
  selector: 'app-documents-consult',
  templateUrl: './documents-consult.component.html',
  styleUrls: ['./documents-consult.component.css']
})
export class DocumentsConsultComponent implements OnInit {
  fecha_sistema = new Date();

  ruta: any = '';
  doc = null;
  documentos: any = {};
  URL_DOCUMENTS = URL_DOCS;

  usuario: any = {};
  pageInfo: any = {};

  private examediApp: any = null;
  private examediClientId = environment.examediClientId;

  selectedYappPdf: string | null = null;

  constructor(
    private _documentServices: DocumentsService,
    public _general: GeneralService,
    private encriptacionService: EncriptacionService
  ) { }

  ngOnInit(): void {
    this.usuario = this.encriptacionService.getUserInfo();
    const use_id = this.usuario._id;

    this.pageInfo = this.encriptacionService.getPageInfo();

    if (this.pageInfo?.cus_can_examedi) {
      this.initExamedi();
    }

    this._documentServices.postListaMisArchivosConsulta()
      .then(result => {
        this.documentos = result;

        for (let docum in this.documentos) {
          let ind = 1;
          let boo_id = 0;

          for (let file of this.documentos[docum]) {
            if (boo_id == file.app_boo_id) {
              ind++;
            } else {
              ind = 1;
            }

            const ind_st = (100 + ind).toString().substring(1);
            file.file_name_desc = file.file_name.replace('XX', ind_st);
            boo_id = file.app_boo_id;
          }
        }
      })
      .catch(error => {
        Swal.fire({
          icon: 'warning',
          title: 'Error al cargar documentos pasados.',
          timer: 2000
        });
      });
  }

  update_doc() {
    this.ngOnInit();
  }

 openYappModal(link: string): void {
  this.selectedYappPdf = link;
  $('#modalYappPdf').modal({
    backdrop: true,
    keyboard: true,
    show: true
  });
}

  confirmOpenYappPdf(): void {
    if (this.selectedYappPdf) {
      window.open(this.selectedYappPdf, '_blank');
    }

    $('#modalYappPdf').modal('hide');
    this.selectedYappPdf = null;
  }
  initExamedi(): void {
    try {
      if (!this.examediClientId) {
        console.error('No existe examediClientId en environment');
        return;
      }

      if (typeof Examedi !== 'undefined') {
        this.examediApp = new Examedi();
        this.examediApp.init({
          clientId: this.examediClientId
        });
      } else {
        console.error('Examedi SDK no está disponible');
      }
    } catch (error) {
      console.error('Error inicializando Examedi:', error);
    }
  }

  openExamedi(): void {
    try {
      if (this.examediApp) {
        this.examediApp.open();
      } else {
        console.error('Examedi no fue inicializado');
      }
    } catch (error) {
      console.error('Error abriendo Examedi:', error);
    }
  }

  
}